import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    paisId: 0,
    pais: null,
    paisNombre: null,
    provinciaId: 0,
    provincia: null,
    provinciaNombre: null,
    nombre: '',
    rowVersion: null,
    
    localidadDatos: [],
};

const mutations = {
    updateField,

    'INICIALIZAR'(state, localidadId) {
        state.id = localidadId;
        state.paisId = 0;
        state.pais = null;
        state.paisNombre = null;
        state.provinciaId = 0;
        state.provincia = null;
        state.provinciaNombre = null;
        state.nombre = '';
        state.rowVersion = null;
    },
    'SET_LOCALIDAD'(state, localidad) {
        state.paisId = (localidad.pais) ? localidad.pais.id : 0;
        state.pais = localidad.pais;
        state.paisNombre = (localidad.pais) ? localidad.pais.nombre.trim() : null;
        state.provinciaId = (localidad.provincia) ? localidad.provincia.id : 0;
        state.provincia = localidad.provincia;
        state.provinciaNombre = (localidad.provincia) ? localidad.provincia.nombre.trim() : null;
        state.nombre = localidad.nombre.toUpperCase().trim();
        state.rowVersion = localidad.rowVersion;
    },
    'SET_PROVINCIA'(state, provincia) {
        state.provincia = provincia;
        state.provinciaId = provincia ? provincia.id : 0;
        state.provinciaNombre = provincia ? provincia.nombre.trim() : null;
    },

    'INICIALIZAR_LOCALIDAD_DATOS' (state) {
        state.localidadDatos = [];
    },
    'SET_LOCALIDAD_DATOS' (state, params) {
        state.localidadDatos = params.localidadDatos;
    },
};

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit }, localidadId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR', localidadId);

            if (localidadId != 0) {
                apiAxios.get('localidades/' + localidadId + '/abm' ) 
                    .then(res => {
                        commit('SET_LOCALIDAD', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        })
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let localidad = {
                provinciaId: parseInt(state.provinciaId),
                nombre: state.nombre.toUpperCase().trim(),
            }

            let url = 'localidades';
            if (state.id != 0) {
                localidad.rowVersion = state.rowVersion;
                url += '/' + state.id;
            }

            apiAxios.post(url, localidad)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    setProvincia: ({commit}, provincia) => {
        commit('SET_PROVINCIA', provincia);
    },

    getLocalidadDatos ( { commit }, localidadId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_LOCALIDAD_DATOS');

            if (localidadId != 0) {
                apiAxios.get('localidades/' + localidadId ) 
                .then(res => {
                    let localidadDatos = [
                        { 'nombre': 'id', 'campo': 'Cod.', 'valor': res.data.id, 'formato': '' },
                        { 'nombre': 'pais', 'campo': 'Pais', 'valor': res.data.pais, 'formato': '' },
                        { 'nombre': 'provincia', 'campo': 'Provincia', 'valor': res.data.provincia, 'formato': '' },
                        { 'nombre': 'nombre', 'campo': 'Nombre', 'valor': res.data.nombre, 'formato': '' },
                    ];
                    
                    let params = {
                        localidadDatos 
                    }
                    commit('SET_LOCALIDAD_DATOS', params);

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
            
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}